import { CustomRiskLevel } from "src/core/constants/risk";
import { RiskCategory } from "src/core/gql/graphql";

export const mapRiskCategory = (category: RiskCategory): CustomRiskLevel => {
  switch (category) {
    case RiskCategory.Category1:
      return CustomRiskLevel.LOW;
    case RiskCategory.NormalGlobal:
    case RiskCategory.Category2:
      return CustomRiskLevel.MEDIUM;
    case RiskCategory.HighGlobal:
    case RiskCategory.Category3:
      return CustomRiskLevel.HIGH;
    default:
      return CustomRiskLevel.UNDEFINED;
  }
};
